import { Button, Input, TextField, Typography, useMediaQuery, useTheme } from "@mui/material";
import { forwardRef, Ref } from "react";


const Contacto = forwardRef((props, ref: Ref<HTMLDivElement>) => {
    const theme = useTheme();
    const isSmall = !useMediaQuery(theme.breakpoints.up('sm'))

    return (
        <div
            ref={ref}
            className="Background" style={{
                padding: isSmall ? '1rem' : '3rem',
                color: 'white',
                minHeight: '100vh',
                justifyContent: isSmall ? 'center' : 'space-around',
                alignItems: isSmall ? 'center' : 'end',
                flexDirection: 'column',
                display: 'flex'
            }}>

            <Typography variant='h4' style={{ fontWeight: 600, textAlign: "center", alignSelf: 'center' }} data-aos='zoom-in'>
                Contáctanos
            </Typography>
            <div className="flex-column" style={{ padding: '3rem', justifyContent: 'center', alignItems: 'center' }}>


                <div className="flex-row-a BackgroundTileNoColor" style={{
                    justifyContent: isSmall ? 'center' : 'end',
                    width: 'fit-content',
                    alignSelf: isSmall ? 'center' : 'end',

                }}>
                    <div className="flex-column">
                        <div style={{ marginBottom: '1rem' }}>
                            <Typography variant="h5" style={{ marginBottom: '1rem', fontWeight: 600 }}>
                                Nombre y apellido(*)
                            </Typography>
                            <TextField
                                helperText='Por favor ingresa tu nombre y apellido'
                                placeholder="Nombre y apellido" />
                        </div>
                        <div style={{ marginBottom: '1rem' }}>
                            <Typography variant="h5" style={{ marginBottom: '1rem', fontWeight: 600 }}>
                                Correo electrónico(*)
                            </Typography>
                            <TextField
                                helperText='Por favor ingresa tu correo electrónico'
                                placeholder="ejemplo@gmail.com" />
                        </div>

                    </div>
                    <div style={{ marginBottom: '1rem', marginLeft: '1rem' }}>
                        <Typography variant="h5" style={{ marginBottom: '1rem', fontWeight: 600 }}>
                            Cuéntanos tu caso(*)
                        </Typography>
                        <TextField id="filled-multiline-static"
                            helperText='Cuéntanos tu caso en detalle'
                            placeholder="Describe tu situación"
                            rows={8} multiline
                            style={{ minWidth: isSmall ? 'auto' : '500px' }}
                        >

                        </TextField>
                    </div>

                </div>
                <Button variant="contained">
                    Enviar
                </Button>
            </div>
        </div>
    )
})

export { Contacto }